import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import FloatingElement from "../FloatingElement/FloatingElement";
import { toast } from 'react-toastify';
import "./Score.css";
import { mapScore } from "../../utils/mapScore";
import { storyline, CHAPTERS, getChapterIndex } from "./storyline";


const Score = ({ score, playing, status }) => {
  const [activeEvent, setActiveEvent] = useState(null);
  const prevScoreRef = useRef(0);
  const [highScore, setHighScore] = useState(() => {
    const stored = localStorage.getItem('flappyTrumpHighScore');
    return stored ? parseInt(stored) : 0;
  });

  // Update high score and last score when game ends
  useEffect(() => {
    // Store last score
    localStorage.setItem('flappyTrumpLastScore', score);

    // Update high score if current score is higher
    if (score > highScore) {
      setHighScore(score);
      localStorage.setItem('flappyTrumpHighScore', score);
    }
  }, [score, highScore]);

  // Fire story events + chapter transitions as the run progresses
  useEffect(() => {
    const event = storyline[score];
    if (event) {
      setActiveEvent(event);

      setTimeout(() => {
        setActiveEvent(null);
      }, 5000);

      toast.info(event.toast,
        {
          hideProgressBar: true,
          icon: false,
          closeButton: false,
          position: "bottom-right"
        });
    }

    // Announce a new chapter when the score crosses its threshold
    const prevScore = prevScoreRef.current;
    if (score > prevScore) {
      const prevChapter = getChapterIndex(prevScore);
      const nextChapter = getChapterIndex(score);
      if (nextChapter > prevChapter) {
        toast(CHAPTERS[nextChapter].title, {
          className: 'chapter-toast',
          hideProgressBar: true,
          icon: false,
          closeButton: false,
          position: "top-center",
          autoClose: 4000,
        });
      }
    }
    prevScoreRef.current = score;
  }, [score]);

  const chapter = CHAPTERS[getChapterIndex(score)];

  return (
    <>
      <div className="Score">
        <div className="Score-day">Day {score}</div>
        <div className="Score-chapter">{chapter.short}</div>
        <div className="Score-stats">
          Best: Day {highScore}
        </div>
      </div>
      {activeEvent && (
        <FloatingElement event={activeEvent} />
      )}
    </>
  );
};

const mapStateToProps = ({ Pipe, Game }) => {
  return {
    score: mapScore(Pipe),
    playing: Game.status === "playing",
    status: Game.status
  };
};
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Score);
